import { apolloClient } from '../GraphQL/config'
import { QUERY_GET_COUNTRIES } from '../GraphQL/queries';

export const getAllAccountsCountries = async () => {
    return await apolloClient.query({ query: QUERY_GET_COUNTRIES }).then(res => {
        let response = res.data?.Sites?.select;

        if (!response) return [];

        let countries = [];

        response.forEach(obj => {
            if (countries.indexOf(obj.country) === -1) {
                countries.push(obj.country);
            }

            return;
        })

        return countries;
    })
}